import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '../../../../../../shared/translate.service';
import {VirtualScrollerComponent} from 'ngx-virtual-scroller';
import {FiltersService} from '../../../filters.service';
import {Filter} from '../../filter-item/filter';


@Component({
  selector: 'app-filter-tree-show-more-modal',
  templateUrl: './filter-tree-show-more-modal.component.html',
  styleUrls: ['./filter-tree-show-more-modal.component.scss']
})
export class FilterTreeShowMoreModalComponent {
  constructor(public activeModal: NgbActiveModal, public translateService: TranslateService, public filtersService: FiltersService) {}
  @ViewChild(VirtualScrollerComponent)
  private virtualScroller: VirtualScrollerComponent;

  @Input() filterBlock;

  selectFilter(filter) {
    filter.selected = true;
    this.filterBlock.forEach(filterCopy => this.appendOrUpdateFilter(filterCopy, this.filtersService.allRegularFacets.value));
    this.filtersService.navigateByFilters();
    this.activeModal.close();
  }

  appendOrUpdateFilter(filterCopy: Filter, filters: Filter[], addToGlobal: boolean = true) {
    const baseResponseFilter = this.findMatchingFilter(filterCopy, filters);
    if (baseResponseFilter) {
      baseResponseFilter.selected = filterCopy.selected;
      baseResponseFilter.or = filterCopy.or;
      baseResponseFilter.excluded = filterCopy.excluded;
      baseResponseFilter.hideInResult = filterCopy.hideInResult;
    } else if (addToGlobal) {
      this.filtersService.appendFilter(filterCopy);
    }
  }

  private findMatchingFilter(filterToFind: Filter, filters: Filter[]): Filter {
    return filters.find(filterCopy => filterCopy.field === filterToFind.field && filterCopy.value === filterToFind.value);
  }
}
